import { gql, GraphQLClient } from 'graphql-request';
import fetchWrapper from '../utils/fetch/fetchWrapper';

const DEALER_TYPES_QUERY_NAME = 'listEVDealersTypes';

const fetchDealersGraphQl = async (token) => {
  let endpoint = process.env.REACT_APP_AMPLIFY_STAGING_ENDPOINT;
  let apiKey = process.env.REACT_APP_AMPLIFY_STAGING_API_KEY;

  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    endpoint = process.env.REACT_APP_AMPLIFY_PRODUCTION_ENDPOINT;
    apiKey = process.env.REACT_APP_AMPLIFY_PRODUCTION_API_KEY;
  }

  const graphQLClient = new GraphQLClient(endpoint, {
    headers: {
      'X-Api-Key': apiKey,
    },
  });

  let query = gql`
    {
      ${DEALER_TYPES_QUERY_NAME} {
        items {
          dealerId
          dealershipHandle
          type,
          oem
        }
        nextToken
      }
    }
  `;

  if (token) {
    query = gql`
          {
            ${DEALER_TYPES_QUERY_NAME}(nextToken: "${token}") {
              items {
                dealerId
                dealershipHandle,
                type,
                oem
              }
              nextToken
            }
          }
        `;
  }

  const data = await graphQLClient.request(query);
  return data;
};

export const fetchDealersType = async (params) => {
  const dealers = [];
  let token;
  while (token !== null) {
    try {
      const data = await fetchDealersGraphQl(token);
      const connection = data?.[DEALER_TYPES_QUERY_NAME];

      if (!connection) {
        return dealers;
      }

      dealers.push(...(connection.items || []));
      token = connection.nextToken;
    } catch (error) {
      const isMissingFieldError = error?.response?.errors?.some(
        (graphQlError) =>
          graphQlError?.message?.includes(`Field '${DEALER_TYPES_QUERY_NAME}'`)
      );

      if (isMissingFieldError) {
        return dealers;
      }

      throw error;
    }
  }

  return dealers;
};

const fetchDealers = async (params) => {
  // Remove null params
  Object.keys(params).forEach(
    (key) => params[key] == null && delete params[key]
  );

  let url = new URL(`${process.env.REACT_APP_API_HOST}/dealers`);

  let searchParams = new URLSearchParams(params);

  url.search = searchParams;

  const json = await fetchWrapper(url, {
    method: 'GET',
  });

  return json.dealers;
};

export default fetchDealers;
